<template>
  <div id="app" class="text-light bg-dark">
    <b-navbar toggleable="lg" type="dark" variant="danger">
      <b-button v-b-toggle.token-sidebar variant="danger">
        <b-icon icon="list"></b-icon>
      </b-button>
      <b-sidebar id="token-sidebar" title="Security Tokens" shadow>
        <div class="px-3 py-2">
          <b-link href="/#/alternative-offerings">Alternative products</b-link><br/>
          <b-link href="/#/bmn2">Blockstream Mining Note 2</b-link><br/>
          <b-link href="/#/ctrl-alt-cell-I">Ctrl Alt Titan Cell I</b-link><br/>
          <b-link href="/#/ctrl-alt-cell-II">Ctrl Alt Titan Cell II</b-link><br/>
          <b-link href="/#/ctrl-alt-cell-IV">Ctrl Alt Titan Cell IV</b-link><br/>
          <b-link href="/#/ustbl">NexBridge US Treasury Bill</b-link><br/>
          <b-link href="/#/investor-returns">Investor Returns</b-link><br/>
        </div>
      </b-sidebar>
      <b-navbar-brand tag="h1" class="mb-0" href="/#/">Bitfinex Securities Analysis</b-navbar-brand>
    </b-navbar>
    <router-view/>
    <b-container>
      <br/><br/>
      Disclaimer: The information presented on this site is not authorized, sponsored, approved, or
      endorsed by Bitfinex or any of the issuers whose securities we attempt to value. The information
      is presented for informational purposes only. There may be data or calculation issues which we
      provide no warranty for.
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
